module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-1-701d61c93f4a3a477f39ef04d6685801.png";